module.exports = __webpack_public_path__ + "static/img/17.56af2b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/sp/17.png
// module id = XCIu
// module chunks = 0